import {Table} from '@devexpress/dx-react-grid-material-ui';
import {useStyles} from 'Utility/styles';

export const CustomNoDataCell = (props) => {
  const {noDataCell} = useStyles();

  return <Table.NoDataCell className={noDataCell} {...props} />;
};
